

import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps
} from "./HelpDialogLayout";

export interface InitiatingSleepDialogProps
  extends HelpDialogLayoutProps {
}
export default function InitiatingSleepDialog(
  props: InitiatingSleepDialogProps
) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <BodyTypographies
          contents={[
            "一般的に、寝床についてから15～30分程度で入眠するのが通常の寝付きとされています。一方で、5分以内に寝付くのは良いことのように感じられますが、実際は「寝付きが良すぎる」とされ、慢性的な睡眠不足の可能性があります。",
          ]}
        />
        <BodyTypographies
          contents={[
            "寝付きが悪くなる原因として、生活習慣以外で特に強く関係しているのがストレスです。",
            "ストレスは、一般的に「不安や悩み」といったネガティブなものが想起されますが、 興奮や期待といったポジティブなストレスも睡眠に影響を与えます。",
            "ストレスを受けると交感神経が優位になり、本来であれば睡眠時に働く副交感神経が抑制されることで、寝付きが悪くなります。",
          ]}
        />
        <BodyTypographies
          contents={[
            "例えば、遠足の前日に眠れないような一時的なストレスは、その要因が解消されれば自然に改善するため、あまり気にする必要はありません。",
            "しかし、仕事や人間関係などのストレスが続く場合は、寝付きを妨げてしまうため、就寝前にストレスを軽減することが重要です。",
            "例えば、ナイトルーチンとして、入浴、ストレッチやヨガ、音楽やアロマなど自分がリラックスできるものを取り入れてみましょう。",
            "また、考え事や不安を紙に書き出すことも有効です。「書く」行為はシンプルながら、感情の浄化作用が強く、また感情を客観視したり新しい視点でとらえる機会ともなり、不安が改善し、ストレスが大幅に軽減することが心理学や社会学にて報告されています。",
            "日中の適度な運動もストレス耐性を高める効果的な手段です。寝付きを良くする効果もあるため、活用してみてください。",
          ]}
        />
      </ContentStack>
    </HelpDialogLayout>
  );
}
